import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Col, Row, Select } from "antd";
import { getApis } from "./api";
import { organisationsUrl, userGenerateJwtTokenUrl } from "./endpoints";
import { setOrgList, setOrgId, setOrgToken } from "../../reducers/orgSlice";
import { ORGANISATION_TYPE } from "./constants";
// import { setOrgDetails } from "./utils";

const ChangeOrganisation = () => {
  const dispatch = useDispatch();
  const authToken = localStorage.getItem("authToken");
  const orgDetails = useSelector((state) => state.org);

  const getOrganisations = async () => {
    await getApis(organisationsUrl, {}, authToken)
      .then((response) => {
        dispatch(setOrgList(response?.data?.filter((org) => org.organisationType !== ORGANISATION_TYPE.ADMINISTRATOR) || []));
      })
      .catch((error) => console.log(error));
  };

  useEffect(() => {
    if (orgDetails?.list?.length > 0) {
      if (!orgDetails?.id) {
        generateOrgToken(orgDetails.id || orgDetails.list[0]?.id);
        dispatch(setOrgId(orgDetails.id || orgDetails.list[0]?.id));
      }
    } else {
      getOrganisations();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orgDetails.list, orgDetails.id]);

  const generateOrgToken = async (orgId) => {
    if (orgId) {
      await getApis(userGenerateJwtTokenUrl, { orgId }, authToken)
        .then((response) => {
          dispatch(setOrgToken(response?.data?.authToken));
          // setOrgDetails(response?.data?.authToken);
        })
        .catch((e) => console.log(e.response?.data?.message));
    } else {
      // NO other orgs
      console.log("No Access to any Organization");
    }
  };

  const organisationChangeFun = (value) => {
    dispatch(setOrgId(value));
    generateOrgToken(value);
  };

  return (
    <Row justify="space-between" className="flex-center mt1">
      <Col xs={12} md={4} className="filter-dropdown">
        <label className="mb05">Organisation</label>
        <Select
          placeholder="Select Organisation"
          size="large"
          showSearch
          value={orgDetails?.id}
          onChange={organisationChangeFun}
          options={orgDetails?.list || []}
          fieldNames={{
            label: "name",
            value: "id",
            options: "options",
          }}
        />
      </Col>
    </Row>
  );
};

export default ChangeOrganisation;
